'use strict';

var React = require('react');
var reactDom = require('react-dom');

const Portal = ({ children, target = globalThis.document?.body }) => {
    const [effectiveTarget, setEffectiveTarget] = React.useState(null);
    React.useEffect(() => {
        setEffectiveTarget(target);
    }, [target]);
    if (!effectiveTarget) {
        return null;
    }
    return reactDom.createPortal(children, effectiveTarget);
};

exports.Portal = Portal;
//# sourceMappingURL=component.js.map
